export default __webpack_public_path__ + "static/media/testimonial1.20870ebf.png";